
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, tuple_type, lambda_type, unit_type, union_type, class_type, list_type, float64_type, option_type, anonRecord_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName, Receiver_$reflection } from "../../Shared/User.js";
import { Storage__get_DisplayName, Storage_$reflection } from "../../Shared/Storage.js";
import { FormState__getValidation, BusinessUnitId__get_unwrap, ConsumableId__get_unwrap, FormState__startLoading, UnassignConsumableV2Dto, FormState__setValidationResponse_5219762A, ConsumableId, RequestedValue$1, FormState_get_empty, RequestedValue$1_$reflection, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { Consumable_$reflection } from "../../Shared/Consumable.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { HookFlow_hasMandatoryUncompletedHooks, HookFlowProcedureModal, HookFlowSections, HookFlow_update, HookFlow_initReturn, HookFlow_completedProcedureIds, HookFlowState, HookFlowKind, HookFlow_empty, HookFlowState_$reflection, HookFlowMsg_$reflection } from "../../Widgets/Procedure/Hooks.js";
import { sortBy, toArray, isEmpty, contains, append, max, tryPick, tryFind, choose, sumBy, map, filter, ofArray, singleton, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ProcedureEntityReferenceDto } from "../../Shared/Procedure.js";
import { Cmd_map, Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_unassignCmd, Cmd_getConsumable } from "../../Requests/Consumable.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { createObj, safeHash, equals, comparePrimitives, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { unwrap, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { fetchWithDecoder as fetchWithDecoder_1, addPrefix as addPrefix_1 } from "../../CommunicationV2.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_uploadImage } from "../../Requests/Files.js";
import { Permission, Permissions_allowsBooking } from "../../Shared/Roles.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../UserPermissions.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { GroupedSelect, Select } from "../../Components/Select.js";
import { TextArea } from "../../Components/TextArea.js";
import { NumberInput } from "../../Components/Input.js";
import { TextValue } from "../../Components/Text.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { whenOpen } from "../../Widgets/Helper.js";
import { Dialog } from "../../Components/Dialog.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { TextButton } from "../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSelectedReceiver", "SetSelectedStorage", "SetComment", "SetQuantity", "UnassignConsumableResponse", "UnassignConsumable", "ReceiversFetched", "ConsumableFetched", "StoragesFetched", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded", "HookMsg"];
    }
}

function Msg_$reflection() {
    return union_type("Consumables.UnassignConsumableDialog.Msg", [], Msg, () => [[["Item", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))]], [["Item", string_type]], [["Item", option_type(float64_type)]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", list_type(Receiver_$reflection())]], [["Item", Consumable_$reflection()]], [["Item", list_type(Storage_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]], [["Item", HookFlowMsg_$reflection()]]]);
}

class State extends Record {
    constructor(FormState, SuccessCallback, OnClose, ConsumableId, Consumable, Quantity, Comment$, ReceiverId, SelectedReceiver, SelectedStorage, QuantityInvalidTranslationKey, IsSelectedReceiverInvalid, IsSelectedStorageInvalid, IsQuantityInvalid, Receivers, Storages, SenderImageFiles, ImageUploading, Hooks) {
        super();
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.ConsumableId = ConsumableId;
        this.Consumable = Consumable;
        this.Quantity = Quantity;
        this.Comment = Comment$;
        this.ReceiverId = ReceiverId;
        this.SelectedReceiver = SelectedReceiver;
        this.SelectedStorage = SelectedStorage;
        this.QuantityInvalidTranslationKey = QuantityInvalidTranslationKey;
        this.IsSelectedReceiverInvalid = IsSelectedReceiverInvalid;
        this.IsSelectedStorageInvalid = IsSelectedStorageInvalid;
        this.IsQuantityInvalid = IsQuantityInvalid;
        this.Receivers = Receivers;
        this.Storages = Storages;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
        this.Hooks = Hooks;
    }
}

function State_$reflection() {
    return record_type("Consumables.UnassignConsumableDialog.State", [], State, () => [["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["ConsumableId", string_type], ["Consumable", RequestedValue$1_$reflection(Consumable_$reflection())], ["Quantity", option_type(float64_type)], ["Comment", string_type], ["ReceiverId", string_type], ["SelectedReceiver", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))], ["SelectedStorage", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))], ["QuantityInvalidTranslationKey", tuple_type(option_type(string_type), option_type(float64_type))], ["IsSelectedReceiverInvalid", bool_type], ["IsSelectedStorageInvalid", bool_type], ["IsQuantityInvalid", bool_type], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type], ["Hooks", HookFlowState_$reflection()]]);
}

const maxSenderImages = 5;

function init(consumableId, successCallback, onClose, receiverId) {
    let bind$0040;
    return [new State(FormState_get_empty(), successCallback, onClose, consumableId, new RequestedValue$1(0, []), undefined, "", receiverId, undefined, undefined, [undefined, undefined], false, false, false, new RequestedValue$1(0, []), new RequestedValue$1(0, []), empty(), false, (bind$0040 = HookFlow_empty(new HookFlowKind(1, []), new ProcedureEntityReferenceDto(2, [consumableId])), new HookFlowState(bind$0040.EntityReference, bind$0040.FlowKind, new RequestedValue$1(0, []), new RequestedValue$1(0, []), bind$0040.ActiveProcedureId, bind$0040.ActiveProcedureTemplateId, bind$0040.ActiveHookSource, bind$0040.CompletedSenderHookTemplateIds, bind$0040.CompletedReceiverHookTemplateIds, bind$0040.CompletedProcedureIds, bind$0040.FormState))), Cmd_batch(ofArray([Cmd_getConsumable((Item) => (new Msg(7, [Item])), (Item_1) => (new Msg(9, [Item_1])), new ConsumableId(parse(consumableId))), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Storage_$reflection())));
    })))), "/api/storages/access", (Item_3) => (new Msg(8, [Item_3])), (Item_4) => (new Msg(9, [Item_4])))]))];
}

function getStockPerUser(consumable) {
    return filter((tupledArg_1) => (tupledArg_1[1] > 0), map((tupledArg) => {
        const events = tupledArg[1];
        return [tupledArg[0], sumBy((event_2) => {
            switch (event_2.tag) {
                case 0:
                    return event_2.fields[0].Quantity;
                case 1:
                    return event_2.fields[0].Quantity;
                case 5:
                    return 0;
                case 3:
                    return 0;
                case 4:
                    return 0;
                case 6:
                    return 0;
                case 7:
                    return 0;
                case 8:
                    return 0;
                case 9:
                    return 0;
                default:
                    return 0;
            }
        }, events, {
            GetZero: () => 0,
            Add: (x_1, y_1) => (x_1 + y_1),
        }) - sumBy((event_3) => {
            switch (event_3.tag) {
                case 0:
                    return 0;
                case 1:
                    return 0;
                case 3:
                    return 0;
                case 4:
                    return 0;
                case 5:
                    return 0;
                case 6:
                    return 0;
                case 7:
                    return 0;
                case 8:
                    return 0;
                case 9:
                    return 0;
                default:
                    return event_3.fields[0].Quantity;
            }
        }, events, {
            GetZero: () => 0,
            Add: (x_2, y_2) => (x_2 + y_2),
        })];
    }, List_groupBy((event_1) => {
        switch (event_1.tag) {
            case 0:
                return event_1.fields[0].ReceiverId;
            case 1:
                return event_1.fields[0].ReceiverId;
            case 5:
                return "";
            case 3:
                return "";
            case 4:
                return "";
            case 6:
                return "";
            case 7:
                return "";
            case 8:
                return "";
            case 9:
                return "";
            default:
                return event_1.fields[0].SenderId;
        }
    }, choose((event) => {
        switch (event.tag) {
            case 0:
                return event;
            case 1:
                return event;
            case 5:
                return undefined;
            case 3:
                return undefined;
            case 4:
                return undefined;
            case 6:
                return undefined;
            case 7:
                return undefined;
            case 8:
                return undefined;
            case 9:
                return undefined;
            default:
                return event;
        }
    }, consumable.Events), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })));
}

function userStock(consumable, userId) {
    return map_1((value) => value[1], tryFind((tupledArg) => (tupledArg[0] === userId), getStockPerUser(consumable)));
}

function update(msg, state) {
    let businessUnitId, file_1;
    switch (msg.tag) {
        case 0:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, msg.fields[0], state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 1:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, msg.fields[0], state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 2:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, msg.fields[0], state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 3:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, msg.fields[0], state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 4: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 5: {
            const matchValue = state.Quantity;
            const matchValue_1 = state.SelectedReceiver;
            const matchValue_2 = state.SelectedStorage;
            const matchValue_3 = state.Consumable;
            let matchResult, quantity_1, consumable, quantity_2, receiver, storage;
            if (matchValue == null) {
                if (matchValue_1 == null) {
                    matchResult = 5;
                }
                else if (matchValue_2 != null) {
                    matchResult = 1;
                }
                else {
                    matchResult = 6;
                }
            }
            else if (matchValue_1 == null) {
                matchResult = 4;
            }
            else if (matchValue_2 != null) {
                if (matchValue === 0) {
                    matchResult = 0;
                    quantity_1 = matchValue;
                }
                else if (matchValue_3.tag === 1) {
                    matchResult = 2;
                    consumable = matchValue_3.fields[0];
                    quantity_2 = matchValue;
                    receiver = matchValue_1;
                    storage = matchValue_2;
                }
                else {
                    matchResult = 3;
                }
            }
            else {
                matchResult = 3;
            }
            switch (matchResult) {
                case 0:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, ["tool.dialog_assign_quantity_empty_validation", undefined], state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                case 1:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, ["tool.dialog_assign_quantity_empty_validation", undefined], state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                case 2: {
                    const userStock_1 = userStock(consumable, receiver.value.Id);
                    if (userStock_1 == null) {
                        return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, ["consumable.dialog_unassign_quantity_to_low", undefined], state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                    }
                    else {
                        const userStock_2 = userStock_1;
                        if (userStock_2 < quantity_2) {
                            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, ["consumable.dialog_unassign_quantity_to_low", userStock_2], state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                        }
                        else {
                            const senderImageUrls = choose((f) => {
                                if (f.tag === 1) {
                                    return f.fields[0].ImageUrl;
                                }
                                else {
                                    return undefined;
                                }
                            }, state.SenderImageFiles);
                            let dto;
                            const CompletedProcedureIds = HookFlow_completedProcedureIds(state.Hooks);
                            dto = (new UnassignConsumableV2Dto(receiver.value.Id, unwrapStorageId(storage.value.Id), state.Comment, quantity_2, "", senderImageUrls, CompletedProcedureIds, undefined));
                            return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, [undefined, undefined], false, false, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_unassignCmd(new ConsumableId(parse(state.ConsumableId)), dto, (Item_2) => (new Msg(4, [Item_2])), (Item_3) => (new Msg(9, [Item_3])))];
                        }
                    }
                }
                case 3:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, false, true, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                case 4:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, true, true, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                case 5:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, true, true, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                default:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, false, false, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
            }
        }
        case 7: {
            const response_1 = msg.fields[0];
            const patternInput_1 = HookFlow_initReturn(new ProcedureEntityReferenceDto(2, [ConsumableId__get_unwrap(response_1.Id)]), map((_arg_2) => _arg_2.fields[0], response_1.LabelIds));
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, new RequestedValue$1(1, [response_1]), state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, patternInput_1[0]), Cmd_batch(ofArray([(businessUnitId = map_1(BusinessUnitId__get_unwrap, response_1.BusinessUnitId), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix_1(url), (refreshOn) => fetchWithDecoder_1(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
                    const pr = response_2.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Receiver_$reflection())));
                }, refreshOn)))(true).then((_arg_4) => {
                    const result_1 = _arg_4;
                    return (result_1.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_1.fields[0]);
                    })())) : (Promise.resolve(result_1.fields[0]));
                });
            })), concat("/api/receivers/active", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item_4) => (new Msg(6, [Item_4])), (Item_5) => (new Msg(9, [Item_5])))), Cmd_map((Item_6) => (new Msg(12, [Item_6])), patternInput_1[1])]))];
        }
        case 6:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, new RequestedValue$1(1, [msg.fields[0]]), state.Storages, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 8:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, new RequestedValue$1(1, [msg.fields[0]]), state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 9:
            return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, false, state.Hooks), Cmd_none()];
        case 10: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x_1, y) => ((x_1 + y) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult_1, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult_1 = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, newFiles, true, state.Hooks), Cmd_uploadImage((Item_7) => (new Msg(11, [Item_7])), (Item_8) => (new Msg(9, [Item_8])), formData)];
                }
                default:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, newFiles, state.ImageUploading, state.Hooks), Cmd_none()];
            }
        }
        case 11: {
            const response_6 = msg.fields[0];
            switch (response_6.tag) {
                case 0:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false, state.Hooks), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false, state.Hooks), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_2, y_1) => (comparePrimitives(x_2, y_1) | 0),
                    })) | 0;
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_6.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false, state.Hooks), Cmd_none()];
                }
            }
        }
        default: {
            const patternInput = HookFlow_update(msg.fields[0], state.Hooks);
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.ConsumableId, state.Consumable, state.Quantity, state.Comment, state.ReceiverId, state.SelectedReceiver, state.SelectedStorage, state.QuantityInvalidTranslationKey, state.IsSelectedReceiverInvalid, state.IsSelectedStorageInvalid, state.IsQuantityInvalid, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading, patternInput[0]), Cmd_map((Item) => (new Msg(12, [Item])), patternInput[1])];
        }
    }
}

function targetStorages(permissions, userId, consumable, storages) {
    return filter((s_1) => Permissions_allowsBooking(permissions, new Permission(7, []), userId, s_1.AssignedUserIds, false), filter((s) => contains(s.Id, map((sps) => sps.StorageId, consumable.StockPerStorage), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), storages));
}

function filterUsers(props) {
    const affectedUserIds = map((tupledArg) => tupledArg[0], getStockPerUser(props.Consumable));
    return filter((u_1) => contains(u_1.Id, affectedUserIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), props.Users);
}

function DialogBody(props) {
    let elems, elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const targetStorages_1 = targetStorages(usePermissions(), props.UserData.UserId, props.Consumable, props.Storages);
    const storageOptions = map((storage) => ({
        label: Storage__get_DisplayName(storage),
        value: storage,
    }), targetStorages_1);
    const receiverOptions = filter((receiver) => (userStock(props.Consumable, receiver.Id) != null), props.Users);
    if (isEmpty(targetStorages_1)) {
        return reactElement("div", createObj(singleton((elems = [reactElement("p", {
            children: t("consumable.dialog_assign_quantity_empty_storage"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_2 = toList(delay(() => append_1(singleton_1(createElement(Select, {
            ComponentState: props.ComponentState,
            IsClearable: false,
            Label: t("consumable.choose_storage"),
            NoOptionsMessage: "select.storage_no_options",
            OnChange: props.SetSelectedStorage,
            Options: storageOptions,
            PlaceholderKey: "select.storage_placeholder",
            TestId: "unassign-consumable-storage-select-test-id",
            ValidationMessage: unwrap(props.IsStorageInvalid ? "tool.switch_storage_missing_storage_validation" : undefined),
            Value: unwrap(props.SelectedStorage),
        })), delay(() => append_1(singleton_1(createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
            ComponentState: props.ComponentState,
            IsClearable: false,
            Key: "select-receiver",
            Label: t("consumable.choose_sender"),
            NoOptionsMessage: "select.employee_no_options",
            OnChange: props.SetSelectedReceiver,
            Options: map((tupledArg) => {
                const receiverType = tupledArg[0];
                const receivers_1 = toArray(sortBy((receiver_3) => receiver_3.label.toLowerCase(), map((receiver_2) => {
                    const matchValue = receiver_2.LocationName;
                    if (matchValue != null) {
                        const locationName = matchValue;
                        if (equals(receiverType, new ReceiverTypeName(4, []))) {
                            return {
                                label: concat(locationName, " - ", ...receiver_2.Name),
                                value: receiver_2,
                            };
                        }
                        else {
                            return {
                                label: concat(receiver_2.Name, " - ", ...locationName),
                                value: receiver_2,
                            };
                        }
                    }
                    else {
                        return {
                            label: receiver_2.Name,
                            value: receiver_2,
                        };
                    }
                }, tupledArg[1]), {
                    Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                }));
                return {
                    label: Helper_receiverTypeNameTranslation(t, receiverType),
                    options: receivers_1,
                };
            }, List_groupBy((receiver_1) => receiver_1.ReceiverType, props.Users, {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            })),
            PlaceholderKey: "select.employee_placeholder",
            Value: unwrap(props.SelectedReceiver),
        }))), delay(() => append_1(singleton_1(createElement(TextArea, {
            ComponentState: props.ComponentState,
            Label: t("general.comment"),
            OnChange: props.SetComment,
            TestId: "unassign-consumable-comment-test-id",
            Value: props.Comment,
        })), delay(() => {
            let matchValue_1, key_3, value_4, arg_1, key_4;
            return append_1(singleton_1(createElement(NumberInput, {
                ComponentState: props.ComponentState,
                Label: t("general.quantity_3"),
                OnChange: props.SetQuantity,
                TestId: "",
                ValidationMessage: unwrap((matchValue_1 = props.QuantityInvalidTranslationKey, (matchValue_1[0] == null) ? undefined : ((matchValue_1[1] != null) ? ((key_3 = matchValue_1[0], (value_4 = matchValue_1[1], (arg_1 = {
                    quantity: value_4,
                }, patternInput[1].t(key_3, arg_1))))) : ((key_4 = matchValue_1[0], t(key_4)))))),
                Value: unwrap(props.Quantity),
            })), delay(() => {
                let elems_1;
                return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_1 = [createElement(TextValue, {
                    FontWeight: "bold",
                    TestId: "",
                    Text: t("assignment_notification.sender_images"),
                }), createElement(ImageUpload, {
                    ComponentState: props.ImageUploading ? "disabled" : props.ComponentState,
                    SelectedFiles: props.SenderImageFiles,
                    SetSelectedFile: props.SetSelectedSenderFiles,
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append_1(singleton_1(createElement(HookFlowSections, {
                    Dispatch: props.HookDispatch,
                    FormState: props.FormState,
                    ReceiverTitleKey: "procedure.hooks.receiver_procedures_return",
                    SenderTitleKey: "procedure.hooks.sender_procedures_return",
                    State: props.Hooks,
                    TestIdPrefix: "return-consumable",
                })), delay(() => {
                    const matchValue_2 = FormState__getValidation(props.FormState, t, "global");
                    if (matchValue_2 == null) {
                        return empty_1();
                    }
                    else {
                        return singleton_1(createElement(ErrorAlert, {
                            Label: matchValue_2,
                        }));
                    }
                }))));
            }));
        })))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    }
}

export function UnassignConsumableDialog(props) {
    let elems, Title, Label_1;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => {
        const tupledArg = init(props.ConsumableId, props.SuccessCallback, props.OnClose, props.UserData.UserId);
        return whenOpen(props.IsOpen, tupledArg[0], tupledArg[1]);
    }, update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_2 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_2.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(singleton((elems = [createElement(HookFlowProcedureModal, {
        Dispatch: (arg) => {
            dispatch(new Msg(12, [arg]));
        },
        State: state_2.Hooks,
    }), createElement(Dialog, (Title = t("consumable.unassign_consumable"), {
        Body: toList(delay(() => {
            const matchValue = state_2.Consumable;
            const matchValue_1 = state_2.Receivers;
            const matchValue_2 = state_2.Storages;
            let matchResult, consumable, receivers, storages;
            if (matchValue.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_2.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                consumable = matchValue.fields[0];
                receivers = matchValue_1.fields[0];
                storages = matchValue_2.fields[0];
            }
            switch (matchResult) {
                case 0:
                    return singleton_1(createElement(DialogBody, {
                        Comment: state_2.Comment,
                        ComponentState: componentState,
                        Consumable: consumable,
                        FormState: state_2.FormState,
                        HookDispatch: (arg_1) => {
                            dispatch(new Msg(12, [arg_1]));
                        },
                        Hooks: state_2.Hooks,
                        ImageUploading: state_2.ImageUploading,
                        IsStorageInvalid: state_2.IsSelectedStorageInvalid,
                        Quantity: unwrap(state_2.Quantity),
                        QuantityInvalidTranslationKey: state_2.QuantityInvalidTranslationKey,
                        SelectedReceiver: unwrap(state_2.SelectedReceiver),
                        SelectedStorage: unwrap(state_2.SelectedStorage),
                        SenderImageFiles: state_2.SenderImageFiles,
                        SetComment: (value_2) => {
                            dispatch(new Msg(2, [value_2]));
                        },
                        SetQuantity: (value_3) => {
                            dispatch(new Msg(3, [value_3]));
                        },
                        SetSelectedReceiver: (value_1) => {
                            dispatch(new Msg(0, [value_1]));
                        },
                        SetSelectedSenderFiles: (files) => {
                            dispatch(new Msg(10, [files]));
                        },
                        SetSelectedStorage: (value) => {
                            dispatch(new Msg(1, [value]));
                        },
                        Storages: storages,
                        UserData: props.UserData,
                        Users: receivers,
                    }));
                default:
                    return singleton_1(createElement(Skeleton, {
                        Variant: "normal",
                    }));
            }
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-unassign-consumable-dialog-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, (Label_1 = t("general.take_back"), {
            ComponentState: (state_2.ImageUploading ? true : HookFlow_hasMandatoryUncompletedHooks(state_2.Hooks)) ? "disabled" : componentState,
            Label: Label_1,
            OnClick: () => {
                dispatch(new Msg(5, []));
            },
            TestId: "save-unassign-consumable-dialog-dialog-test-id",
            Variant: "blueButton",
        }))]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

